<template>
  <p id="no-records" :class="classes">
    {{ $t("NoRecords") }}
  </p>
</template>

<script>
export default {
  props: {
      classes:{
          type: String,
          default: ""
      }
  },
};
</script>

<style>
#no-records{
text-align: center;
width: 100%;
margin: 16px auto;
font-size: 16px;
line-height:1.2;
font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/NoRecords.vue